import { useRef, useEffect } from "react";

const Cursor = ({}) => {
  useEffect(() => {
    window.addEventListener("mousemove", trackCursor);
    window.addEventListener("mousedown", transformCursor);
    window.addEventListener("mouseup", recoverCursor);
    return () => {
      window.removeEventListener("mousemove", trackCursor);
      window.removeEventListener("mousedown", transformCursor);
      window.removeEventListener("mouseup", recoverCursor);
    };
  }, []);

  const cursor = useRef();

  const trackCursor = (e) => {
    if (cursor.current) {
      cursor.current.style.left = e.clientX + "px";
      cursor.current.style.top = e.clientY + "px";
    }
    return true;
  };

  const transformCursor = (e) => {
    if (cursor.current) {
      cursor.current.style.backgroundColor = "red";
    }
    return true;
  };

  const recoverCursor = (e) => {
    if (cursor.current) {
      cursor.current.style.backgroundColor = "white";
    }
    return true;
  };

  return (
    <div
      ref={cursor}
      style={{
        position: "absolute",
        zIndex: 9999,
        color: "red",
        pointerEvents: "none",
        height: 5,
        width: 5,
        borderRadius: 3,
        backgroundColor: "white",
        boxShadow: "0 0 5px black",
        transform: "translate(-50%, -50%)",
      }}
    ></div>
  );
};

export default Cursor;
